import { Edit, SimpleForm, TextField, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { ColorPicker } from '../../components/ColorPicker';

export const TagEdit = (props: unknown) => (
  <Edit {...props} title={<CustomTitle />}>
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="title" />
      <ColorPicker source="bgColor" label="Background color" help="opcional, color de fondo de la celda en el grid" />
      <ColorPicker source="fgColor" label="Foreground color" help="opcional, color de texto de la celda en el grid" />
    </SimpleForm>
  </Edit>
);
